import type { MediaKind } from "@velizhanin-dev/bot-scenario"

/** Русское название вида вложения: используется и в конструкторе ботов, и в аудитории. */
export const MEDIA_KIND_LABELS: Record<MediaKind, string> = {
	photo: "Фото",
	video: "Видео",
	animation: "GIF-анимация",
	audio: "Аудио",
	voice: "Голосовое",
	video_note: "Кружок",
	document: "Файл",
	sticker: "Стикер",
}
